import { PortalReferralDisplayStatus } from '@app/services/api/api.types';

const displayStatusLabels: Record<PortalReferralDisplayStatus, string> = {
  [PortalReferralDisplayStatus.REFERRAL_SUBMITTED]: 'Referral submitted',
  [PortalReferralDisplayStatus.CONTACTED]: 'Contacted',
  [PortalReferralDisplayStatus.IN_PROGRESS]: 'In progress',
  [PortalReferralDisplayStatus.REJECTED]: 'Rejected',
  [PortalReferralDisplayStatus.BOOKED]: 'Booked',
  [PortalReferralDisplayStatus.JOURNEY_COMPLETED]: 'Journey completed',
  [PortalReferralDisplayStatus.SUCCESS]: 'Success',
  [PortalReferralDisplayStatus.INELIGIBLE]: 'Ineligible',
  [PortalReferralDisplayStatus.EXPIRED]: 'Expired',
};

export function referralDisplayStatusLabel(status: PortalReferralDisplayStatus) {
  return displayStatusLabels[status] ?? status;
}

export function showDaysLeftToBook(status: PortalReferralDisplayStatus) {
  return (
    status === PortalReferralDisplayStatus.REFERRAL_SUBMITTED ||
    status === PortalReferralDisplayStatus.CONTACTED ||
    status === PortalReferralDisplayStatus.IN_PROGRESS
  );
}
